import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import $ from "jquery";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-select/dist/js/bootstrap-select.min.js";
import {
  clearAll,
  onGetAdditionalDocuments,
  onUpdateCertificate,
  setCertificateDetails,
  showCertificateFormFunc,
  showCertificateUpdateFormFunc,
} from "../../../../config/redux/slice/transfereeUserSlice";
import { useDispatch, useSelector } from "react-redux";
import { appApi } from "../../../../utils/endpoints/appApi";
import { getRequest, postRequest } from "../../../../helpers/request";
import {
  onAddCertificate,
  setErrorMessageTransfereeUser,
  setLoadingTransfereeUser,
} from "../../../../config/redux/slice/transfereeUserSlice";
import { Spinner } from "../../../components";
import {
  // formatNumber,
  getCurrencySymbol,
  truncateMiddle,
} from "../../../../helpers/helpers";
import moment from "moment";
import {
  onGetBanks,
  setCertificateDetailsGeneral,
  showDocumentModalFunc,
} from "../../../../config/redux/slice/appSlice";
import { document_list } from "../../../../constants/english";

export default function EditCertificateUploadForm({ certificateObject }) {
  const dispatch = useDispatch();
  const {
    register,
    unregister,
    handleSubmit,
    watch,
    getValues,
    setError,
    setValue,
    formState: { errors },
    reset,
  } = useForm({ mode: "onTouched" });
  // const [amount_requested, setRealAmountReq] = useState("")
  //  const [amount_available, setRealAmountAvail] = useState("")
  const [whtRates, setWhtRates] = useState([]);
  const { currencies, banks } = useSelector((state) => state.app);
  const {
    transfereeUserLoading,
    transfereeUserErrorMsg,
    certificateManagement: {
      certificatesData,
      newData,
      showCertificateUpdateForm,
      additionalDocs,
    },
  } = useSelector((state) => state.transfereeUser);
  const [additionalDocsName, setAdditionalDocsName] = useState([]);
  const { token } = useSelector((state) => state.authData);

  const [file_names, setfileUploads] = useState([]);
  const [documents, setfileDoc] = useState({});

  const [formData, setFormData] = useState(new FormData());
  const issueDate = watch("certificate_date");
  useEffect(() => {
    // getWHTRates()
    $(function () {
      $(".my-select").selectpicker();
    });
    getAdditionalDocs();
    getBanks();
  }, []);

  const closeModal = () => {
    dispatch(clearAll({}));
    dispatch(showCertificateUpdateFormFunc({ modal: false }));
  };

  const getBanks = async () => {
    const res = await getRequest(
      token,
      `${appApi.banks}`,
      {},
      dispatch,
      "",
      onGetBanks,
      "",
    );
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";

    // Remove commas only (DO NOT touch decimals)
    const clean = String(value).replace(/,/g, "");

    // Reject invalid numbers
    if (!/^\d+(\.\d{0,2})?$/.test(clean)) return value;

    const num = Number(clean);
    if (Number.isNaN(num)) return value;

    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatAmount = (e, value, name) => {
    let originalValue = value.replace(",", "");
    originalValue = originalValue.replace(".00", "");
    if (e.key === "Backspace" || e.keyCode === 8) {
      e.preventDefault();
      originalValue = originalValue.replace(".0", "");
      originalValue = originalValue.replace(".", "");
      originalValue = originalValue.slice(0, originalValue.length - 1);
      if (isNaN(Number(originalValue))) {
        setError(name, {
          type: "manual",
          message: "Invalid Input",
        });
        return value;
      } else {
        let formattedAmount = Number(originalValue).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return formattedAmount;
      }
    } else {
      // Format the numeric value with a thousands separator and ".00" at the end
      if (isNaN(Number(originalValue))) {
        setError(name, {
          type: "manual",
          message: "Invalid Input",
        });
        return value;
      } else {
        let formattedAmount = Number(originalValue).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return formattedAmount;
      }
    }
  };

  const convertToNumber = (value = "") =>
    Number(value.replace(/,/g, "").replace(/\.00$/, ""));

  // const convertToNumber = (stringValue) => {
  //   let originalValue = stringValue.replace(",", "");
  //   originalValue = originalValue.replace(".00", "");
  //   return originalValue;
  // };

  const getAdditionalDocs = async () => {
    const res = await getRequest(
      token,
      `${appApi.getAdditionalDocuments(certificateObject.ID)}`,
      {},
      dispatch,
      "",
      onGetAdditionalDocuments,
      "",
    );
    if (res != undefined && res.status < 400) {
      let y = Array.from(additionalDocs, (option) => option.FILE_NAME);
      setAdditionalDocsName(y);
    }
  };

  const onSubmit = async (data) => {
    // dispatch(onUpdateCertificate())
    dispatch(clearAll({}));
    const todayDate = moment();
    const expiryDate = moment(data.expiry_date);
    let required_docs = document_list.filter(
      (document) => document.isRequired == true,
    );
    // let checker = required_docs.every(v => file_names.includes(v));
    if (expiryDate.isBefore(todayDate) || expiryDate.isSame(todayDate)) {
      dispatch(
        setErrorMessageTransfereeUser({ message: "Certificate has expired" }),
      );
    }
    // else if(!checker){
    //   dispatch(setErrorMessageTransfereeUser({message: 'Required files missing'}))
    // }
    else {
      let amount_requested = convertToNumber(data.amount_requested_temp);
      let amount_on_certificate = convertToNumber(
        data.amount_on_certificate_temp,
      );
      let fileNamesList = Object.values(documents);
      let fileNames = Array.from(fileNamesList, (option) => option[0]);
      fileNames = fileNames.join(",");
      data = {
        ...data,
        issuer: "NOTAP",
        reference: certificateObject.CERTIFICATE_REFERENCE_CODE,
        otp: certificateObject.OTP,
        amount_on_certificate,
        amount_requested,
        documents,
        file_names: fileNames,
      };
      for (let key in data) {
        if (key == "documents") {
          if (fileNamesList.length != 0) {
            for (let x in data[key]) {
              formData.append(`${key}`, data[key][x][1]);
            }
          }
          // formData.append(key, data[key])
        } else if (typeof data[key] == "object") {
          if (data[key].length != 0) {
            formData.append(key, data[key][0]);
          }
        } else {
          if (key == "file_names") {
            if (data[key] != "") {
              formData.append(key, data[key]);
            }
          } else {
            formData.append(key, data[key]);
          }
        }
      }
      const res = await postRequest(
        token,
        `${appApi.updateCertificate}`,
        formData,
        dispatch,
        setLoadingTransfereeUser,
        "",
        setErrorMessageTransfereeUser,
        true,
      );
      if (res != undefined && res.status < 400) {
        setFormData(new FormData());
        dispatch(
          setCertificateDetailsGeneral({
            details: res.data.data,
            modal: false,
          }),
        );
        dispatch(
          setCertificateDetails({ details: res.data.data, modal: false }),
        );
        dispatch(onUpdateCertificate());
      } else {
        setFormData(new FormData());
      }
    }
  };

  useEffect(() => {
    if (certificateObject?.AMOUNT_REQUEST) {
      setValue(
        "amount_requested_temp",
        formatNumber(certificateObject.AMOUNT_REQUEST),
        { shouldDirty: false },
      );
    }
  }, [certificateObject, setValue]);

  const normalizeCurrency = (value) => {
    if (!value) return "";

    const raw = value.replace(/[^\d]/g, "");

    if (!raw) return "";

    return Number(raw).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  function addFileName(e, idValue) {
    let fileName = e.target.value;
    if (fileName !== "") {
      fileName = fileName.replace(/^.*[\\\/]/, "");
      document.getElementById(idValue).innerHTML = truncateMiddle(fileName, 30);
    } else {
      document.getElementById(idValue).innerHTML = "No file Chosen";
    }
  }

  function removeFile(fileReference, fileName, fileId) {
    unregister(fileReference);
    const fileIndex = file_names.findIndex(
      (singleItem) => singleItem == fileName,
    );
    file_names.splice(fileIndex, 1);
    // documents.splice(fileIndex, 1)
    let x = fileId;
    const { [x]: removedProperty, ...newDouments } = documents;
    setfileUploads(file_names);
    setfileDoc(newDouments);
    // setfileUploads((prev)=>prev.filter((singleItem)=>singleItem!=fileName))
  }

  return (
    <div
      className="modal fade show"
      id="basicModal"
      tabIndex="-1"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.3)",
        overflowY: "auto",
      }}
    >
      <div
        style={{ overflowY: "auto" }}
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <form
            onSubmit={handleSubmit(onSubmit)}
            autoComplete={"off"}
            encType="multipart/form-data"
            noValidate
          >
            <div className="modal-header px-4">
              <h6 className="modal-title" id="exampleModalCenterTitle">
                Update Certificate
              </h6>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  closeModal();
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body px-4 px-md-7">
              <div>
                <h6 className="mb-3 font-weight-bold">
                  Certificate Information
                </h6>
                <div className="row mb-2">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="certificate_number">
                        Reference ID (File No)
                      </label>
                      <input
                        defaultValue={certificateObject?.CERTIFICATE_NUMBER}
                        type="text"
                        readOnly
                        className="form-control input-lg"
                        id="certificate_number"
                        {...register("certificate_number", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                          // pattern: {
                          //   value: /^[0-9]+$/i,
                          //   message: "*invalid input",
                          // },
                        })}
                      />
                      {errors?.certificate_number?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.certificate_number?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="certificate_number_two">
                        Certificate Number
                      </label>
                      <input
                        defaultValue={certificateObject?.CERTIFICATE_NUMBER_TWO}
                        type="text"
                        className="form-control input-lg"
                        id="certificate_number_two"
                        {...register("certificate_number_two", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                        })}
                      />
                      {errors?.certificate_number_two?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.certificate_number_two?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="certificate_date">
                        Certificate Issue Date
                      </label>
                      <input
                        defaultValue={certificateObject?.CERTIFICATE_DATE}
                        type="date"
                        max={moment().format("YYYY-MM-DD")}
                        className="form-control input-lg"
                        id="certificate_date"
                        {...register("certificate_date", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                        })}
                      />
                      {errors?.certificate_date?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.certificate_date?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="expiry_date">
                        Certificate Expiry Date
                      </label>
                      <input
                        defaultValue={certificateObject?.EXPIRY_DATE}
                        type="date"
                        min={issueDate ?? null}
                        className="form-control input-lg"
                        id="expiry_date"
                        {...register("expiry_date", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                        })}
                      />
                      {errors?.expiry_date?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.expiry_date?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="effective_date">
                        Certificate Effective Date
                      </label>
                      <input
                        defaultValue={certificateObject?.EFFECTIVE_DATE}
                        type="date"
                        className="form-control input-lg"
                        id="effective_date"
                        {...register("effective_date", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                        })}
                      />
                      {errors?.effective_date?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.effective_date?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="currency">Currency</label>
                      <select
                        defaultValue={certificateObject?.CURRENCY}
                        className="form-control rounded-0 selectpicker my-select"
                        id="currency"
                        data-live-search="true"
                        disabled
                      >
                        <option value={""}>Select Currency</option>
                        {currencies.map((currencyItem, i) => {
                          return (
                            <option key={i} value={currencyItem.name}>
                              {currencyItem.name}
                            </option>
                          );
                        })}
                      </select>
                      {errors?.currency?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.currency?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="amount_on_certificate_temp">
                        Amount On Certificate
                      </label>
                      <input
                        defaultValue={formatNumber(
                          certificateObject?.AMOUNT_ON_CERTIFICATE,
                        )}
                        type="text"
                        className="form-control input-lg"
                        id="amount_on_certificate_temp"
                        {...register("amount_on_certificate_temp", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                          // pattern: {
                          //   value: /^[1-9]\d*$/i,
                          //   message: '*invalid input'
                          // }
                        })}
                        onKeyUp={(e) => {
                          if (e.key === "Backspace" || e.keyCode === 8) {
                            e.preventDefault();
                          }
                          setValue(
                            "amount_on_certificate_temp",
                            formatAmount(
                              e,
                              e.target.value,
                              "amount_on_certificate_temp",
                            ),
                          );
                        }}
                      />
                      {errors?.amount_on_certificate_temp?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.amount_on_certificate_temp?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="amount_requested_temp">
                        Amount Requested
                      </label>
                      <input
                        defaultValue={formatNumber(
                          certificateObject?.AMOUNT_REQUEST,
                        )}
                        type="text"
                        className="form-control input-lg"
                        id="amount_requested_temp"
                        {...register("amount_requested_temp", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                          validate: (value) =>
                            Number(convertToNumber(value)) <=
                              Number(
                                convertToNumber(
                                  watch("amount_on_certificate_temp"),
                                ),
                              ) || "Amount greater than amount on certificate",
                          // pattern: {
                          //   value: /^[1-9]\d*$/i,
                          //   message: '*invalid input'
                          // }
                        })}
                        onBlur={(e) => {
                          setValue(
                            "amount_requested_temp",
                            formatNumber(e.target.value),
                            { shouldValidate: true },
                          );
                        }}

                        // onKeyUp={(e) => {
                        //   if (e.key === "Backspace" || e.keyCode === 8) {
                        //     e.preventDefault();
                        //   }
                        //   setValue(
                        //     "amount_requested_temp",
                        //     formatAmount(
                        //       e,
                        //       e.target.value,
                        //       "amount_requested_temp",
                        //     ),
                        //   );
                        // }}
                      />
                      {errors?.amount_requested_temp?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.amount_requested_temp?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h6 className="mb-3 font-weight-bold">Bank Information</h6>
                <div className="row mb-2">
                  {banks.length > 0 && (
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="bank_id">Select your Bank</label>
                        <select
                          defaultValue={certificateObject?.BANK_ID}
                          className="form-control rounded-0"
                          id="bank_id"
                          disabled
                        >
                          <option value={""}>Select Bank</option>
                          {banks.map((bank) => {
                            return (
                              <option key={bank.ID} value={bank.ID}>
                                {bank.BANK_NAME}
                              </option>
                            );
                          })}
                        </select>
                        {errors?.bank_id?.message && (
                          <div className="text-danger small mt-1">
                            {errors?.bank_id?.message}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="contact_name">Contact Name</label>
                      <input
                        defaultValue={certificateObject?.CONTACT_NAME}
                        type="text"
                        className="form-control input-lg"
                        id="contact_name"
                        disabled
                      />
                      {errors?.contact_name?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.contact_name?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="contact_email">Contact Email</label>
                      <input
                        defaultValue={certificateObject?.CONTACT_EMAIL}
                        type="text"
                        className="form-control input-lg"
                        id="contact_email"
                        disabled
                      />
                      {errors?.contact_email?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.contact_email?.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="contact_phone">
                        Contact Phone Number
                      </label>
                      <input
                        defaultValue={certificateObject?.CONTACT_PHONE}
                        type="text"
                        className="form-control input-lg"
                        id="contact_phone"
                        disabled
                      />
                      {errors?.contact_phone?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.contact_phone?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h6 className="mb-3 font-weight-bold">Documents Upload</h6>
                <div className="row mt-4">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <div>
                        <label className="mr-2" htmlFor="certificate_file">
                          Certificate
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            dispatch(
                              showDocumentModalFunc({
                                modal: true,
                                url: certificateObject?.CERTIFICATE_FILE_PATH,
                              }),
                            );
                          }}
                          className="btn btn-sm text-white btn-primary"
                        >
                          View Document
                        </button>
                      </div>
                      <div>
                        <div className="custom-file mb-1">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="certificate_file"
                            {...register("certificate_file")}
                            onChange={(e) => {
                              addFileName(e, "custom-certificate");
                            }}
                          />
                          <label
                            id="custom-certificate"
                            className="custom-file-label"
                          >
                            Choose file...
                          </label>
                          {errors?.certificate_file?.message && (
                            <div className="text-danger small mt-1">
                              {errors?.certificate_file?.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <div>
                        <label className="mr-2" htmlFor="stamped_agreement">
                          Stamped Agreement
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            dispatch(
                              showDocumentModalFunc({
                                modal: true,
                                url: certificateObject?.STAMPED_AGREEMENT,
                              }),
                            );
                          }}
                          className="btn btn-sm text-white btn-primary"
                        >
                          View Document
                        </button>
                      </div>
                      <div>
                        <div className="custom-file mb-1">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="stamped_agreement"
                            {...register("stamped_agreement")}
                            onChange={(e) => {
                              addFileName(e, "custom-certificate2");
                            }}
                          />
                          <label
                            id="custom-certificate2"
                            className="custom-file-label"
                          >
                            Choose file...
                          </label>
                          {errors?.stamped_agreement?.message && (
                            <div className="text-danger small mt-1">
                              {errors?.stamped_agreement?.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-6">
                    <div className="form-group">
                      <div>
                        <label className="mr-2" htmlFor="cover_letter">
                          Cover Letter
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            dispatch(
                              showDocumentModalFunc({
                                modal: true,
                                url: certificateObject?.COVER_LETTER,
                              }),
                            );
                          }}
                          className="btn btn-sm text-white btn-primary"
                        >
                          View Document
                        </button>
                      </div>
                      <div>
                        <div className="custom-file mb-1">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="cover_letter"
                            {...register("cover_letter")}
                            onChange={(e) => {
                              addFileName(e, "custom-certificate3");
                            }}
                          />
                          <label
                            id="custom-certificate3"
                            className="custom-file-label"
                          >
                            Choose file...
                          </label>
                          {errors?.cover_letter?.message && (
                            <div className="text-danger small mt-1">
                              {errors?.cover_letter?.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <>
                    {additionalDocs?.map((fileItem, i) => {
                      return (
                        <div key={fileItem.ID} className="col-lg-6">
                          <div className="form-group">
                            <div>
                              <label
                                className="mr-2"
                                htmlFor={`file_${fileItem.ID}`}
                              >
                                {fileItem.FILE_NAME}
                              </label>
                              <button
                                type="button"
                                onClick={() => {
                                  dispatch(
                                    showDocumentModalFunc({
                                      modal: true,
                                      url: fileItem.FILE_URL,
                                    }),
                                  );
                                }}
                                className="btn btn-sm text-white btn-primary"
                              >
                                View Document
                              </button>
                            </div>
                            <div>
                              <div className="custom-file mb-1">
                                <input
                                  type="file"
                                  className="custom-file-input"
                                  id={`file_${fileItem.ID}`}
                                  {...register(`file_${fileItem.ID}`)}
                                  onChange={(e) => {
                                    addFileName(
                                      e,
                                      `custom-certificate${fileItem.ID + 6}`,
                                    );
                                    // setfileDoc((prev)=>[...prev, {
                                    //   id: fileItem.id,
                                    //   fileItem: e.target.files[0]
                                    // }])

                                    if (e.target.files.length == 0) {
                                      removeFile(
                                        `file_${fileItem.ID}`,
                                        fileItem.FILE_NAME,
                                        fileItem.ID,
                                      );
                                    } else {
                                      setfileDoc((prev) => {
                                        return {
                                          ...prev,
                                          [fileItem.ID]: [
                                            fileItem.FILE_NAME,
                                            e.target.files[0],
                                          ],
                                        };
                                      });
                                    }
                                  }}
                                />
                                <label
                                  id={`custom-certificate${fileItem.ID + 6}`}
                                  className="custom-file-label"
                                >
                                  Choose file...
                                </label>
                                {errors[`file_${fileItem.ID}`]?.message && (
                                  <div className="text-danger small mt-1">
                                    {errors[`file_${fileItem.ID}`]?.message}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="uploads">
                        Select Additional Document To Upload
                      </label>
                      <select
                        className="form-control rounded-0"
                        id="uploads"
                        {...register("uploads")}
                        onChange={(e) => {
                          setfileUploads((prev) => {
                            return [...prev, e.target.value];
                          });
                        }}
                      >
                        <option value={""}>Select Document</option>
                        {document_list
                          ?.filter(
                            (item) =>
                              additionalDocsName.includes(item.name) == false,
                          )
                          .map((documentItem, i) => {
                            return (
                              <React.Fragment key={documentItem.id}>
                                {file_names.includes(documentItem.name) ==
                                  false && (
                                  <option value={documentItem.name}>
                                    {documentItem.name}
                                  </option>
                                )}
                              </React.Fragment>
                            );
                          })}
                      </select>
                      {errors?.uploads?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.uploads?.message}
                        </div>
                      )}
                    </div>
                  </div>
                  <>
                    {document_list
                      ?.filter((fileItem, i) =>
                        file_names.includes(fileItem.name),
                      )
                      .map((fileItem, i) => {
                        return (
                          <div key={fileItem.id} className="col-lg-6">
                            <div className="form-group">
                              <label
                                className="mr-2"
                                htmlFor={`${fileItem.reference}`}
                              >
                                {fileItem.name}
                              </label>
                              {!fileItem.isRequired && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    removeFile(
                                      fileItem.reference,
                                      fileItem.name,
                                      fileItem.id,
                                    );
                                  }}
                                  className="btn btn-sm text-white bg-danger"
                                >
                                  <span className="mr-1" aria-hidden="true">
                                    ×
                                  </span>
                                  Remove
                                </button>
                              )}
                              <div>
                                <div className="custom-file mb-1">
                                  <input
                                    type="file"
                                    className="custom-file-input"
                                    id={`${fileItem.reference}`}
                                    {...register(`${fileItem.reference}`, {
                                      required: {
                                        value: true,
                                        message: "*this field is required",
                                      },
                                      // validate:{
                                      //   required: value =>`${fileItem.isRequired}`
                                      // }
                                    })}
                                    onChange={(e) => {
                                      addFileName(
                                        e,
                                        `custom-certificate${fileItem.id}`,
                                      );
                                      // setfileDoc((prev)=>[...prev, {
                                      //   id: fileItem.id,
                                      //   fileItem: e.target.files[0]
                                      // }])
                                      setfileDoc((prev) => {
                                        return {
                                          ...prev,
                                          [fileItem.id]: [
                                            fileItem.name,
                                            e.target.files[0],
                                          ],
                                        };
                                      });
                                    }}
                                  />
                                  <label
                                    id={`custom-certificate${fileItem.id}`}
                                    className="custom-file-label"
                                  >
                                    Choose file...
                                  </label>
                                  {errors[`${fileItem.reference}`]?.message && (
                                    <div className="text-danger small mt-1">
                                      {errors[`${fileItem.reference}`]?.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </>
                </div>
              </div>
            </div>
            <div className="modal-footer px-4 d-flex align-items-center">
              <button
                disabled={transfereeUserLoading ? true : false}
                onClick={() => {
                  reset();
                }}
                type="button"
                className="btn btn-smoke"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <div>
                {transfereeUserLoading ? (
                  <Spinner />
                ) : (
                  <button type="submit" className="btn btn-primary">
                    Update Information
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
